import { useNavigate } from '@tanstack/react-router';
import { useQueryClient } from '@tanstack/react-query';
import { useCreateExtraction, getListExtractionsQueryKey } from '@sara/api-client';
import { ExtractionForm, type ExtractionFormValues } from '../../components/ExtractionForm';
import { useOrgSlug } from '../../../auth';

interface CreateExtractionFormContainerProps {
  orgId: string;
}

export function CreateExtractionFormContainer({ orgId }: CreateExtractionFormContainerProps) {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const orgSlug = useOrgSlug();

  const { mutate, isPending, error } = useCreateExtraction({
    mutation: {
      onSuccess: (data) => {
        void queryClient.invalidateQueries({
          queryKey: getListExtractionsQueryKey(),
        });
        void navigate({
          to: '/orgs/$orgSlug/extractions/$extractionId',
          params: { orgSlug, extractionId: data.id },
        });
      },
    },
  });

  function handleSubmit(values: ExtractionFormValues) {
    mutate({
      data: {
        orgId,
        name: values.name,
        description: values.description,
        prompt: values.prompt,
        outputSchema: JSON.parse(values.outputSchema) as Record<string, unknown>,
      },
    });
  }

  return (
    <ExtractionForm
      mode="create"
      onSubmit={handleSubmit}
      isPending={isPending}
      error={
        error ? (error instanceof Error ? error.message : 'Failed to create extraction') : null
      }
    />
  );
}
